// List filters keep their date range in the URL as YYYY-MM-DD.
// The calendar hands back local midnight, so the date has to be read off the
// local parts. toISOString() would roll it back a day east of UTC, and that
// shift would compound every time the range round-tripped through the URL.
export const toDateParam = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

export const fromDateParam = (value: string | null): Date | undefined => {
  if (!value) return undefined;
  const [year, month, day] = value.split('-').map(Number);
  if (!year || !month || !day) return undefined;
  return new Date(year, month - 1, day);
};
